define.alias("shared/components/shared/ui/icon-tooltip", "media/components/shared/ui/icon-tooltip");